import React, { useState, useMemo } from "react";
import { Box, Button, Checkbox, TextField, Tooltip } from "@mui/material";
import { OverlayScrollbarsComponent } from "overlayscrollbars-react";
import EllipsisWithTooltip from "../PricingModal1/EllipsisWithTooltip";

const PortfolioDetailsPage = ({
    selectedPortfolio,
    availableHotels,
    selectedHotels,
    checkedLeft,
    checkedRight,
    hotelsData,
    emptyHotelListLeft,
    emptyHotelListRight,
    handleBackButton,
    handleSelectAllLeft,
    handleSelectAllRight,
    handleLeftCheck,
    handleRightCheck,
    handleAdd,
    handleRemove,
    unCheckedIcon,
    checkedIcon,
    handlePortfolioNameChange,
    nameError
}) => {

    const TOOLTIP_ADD_PROPERTIES_FIRST = "Please add the selected properties first.";
    const TOOLTIP_REMOVE_PROPERTIES_FIRST = "Please remove the selected properties first.";

    // Search state
    const [searchQuery, setSearchQuery] = useState("");

    // Filter Available Hotels
    const filteredAvailableHotels = useMemo(() => {
        if (!searchQuery.trim()) return availableHotels;

        return availableHotels.filter((hotel) =>
            hotel.name?.toLowerCase().includes(searchQuery.toLowerCase())
        );
    }, [availableHotels, searchQuery]);

    // Filter Selected Hotels
    const filteredSelectedHotels = useMemo(() => {
        if (!searchQuery.trim()) return selectedHotels;

        return selectedHotels.filter((hotel) =>
            hotel.name?.toLowerCase().includes(searchQuery.toLowerCase())
        );
    }, [selectedHotels, searchQuery]);

    const isNameEmpty = selectedPortfolio.name.trim() === "" && nameError;
    const hasError = isNameEmpty || nameError;
    // const tooltipMessage = selectedPortfolio.name.trim() === "" || selectedPortfolio.name.trim().length >=20 ? "Portfolio name is required (max 20 characters)" : nameError ? "This name is already taken. Please choose another." : "";
    const tooltipMessage = selectedPortfolio.name.trim() === "" && nameError ? "Portfolio name is required " : nameError ? "This name is already taken. Please choose another." : "";

    return (
        <Box className="portfolio-details-page">

            <Box className="portfolio-details-header">
                <div className='back-btn' onClick={handleBackButton}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="#333333" viewBox="0 0 256 256"><path d="M224,128a8,8,0,0,1-8,8H59.31l58.35,58.34a8,8,0,0,1-11.32,11.32l-72-72a8,8,0,0,1,0-11.32l72-72a8,8,0,0,1,11.32,11.32L59.31,120H216A8,8,0,0,1,224,128Z"></path></svg>
                </div>
                <div className="portfolio-name">
                    <Tooltip
                        title={tooltipMessage}
                        open={!!tooltipMessage}
                        arrow
                        placement="bottom-start"
                    >
                        <TextField
                            // className={nameError || selectedPortfolio.name === "" ? 'name-input error' : 'name-input'}
                            className={`name-input ${(hasError) ? "error" : ""}`}
                            value={selectedPortfolio.name}
                            onChange={(e) => handlePortfolioNameChange(e.target.value)}
                            variant="standard"
                            placeholder='Enter portfolio name'
                            autoFocus
                        //error={!!nameError}
                        />
                    </Tooltip>
                </div>
            </Box>

            <div className='portfolio-details-search'>
                <TextField
                    className='search-box'
                    fullWidth
                    placeholder="Search"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    InputProps={{
                        startAdornment: (
                            <div style={{ marginRight: '8px', marginTop: '5px' }}>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill={searchQuery !== '' ? "#333" : "#B2B2B2"}
                                    viewBox="0 0 256 256"
                                >
                                    <path d="M229.66,218.34l-50.07-50.06a88.11,88.11,0,1,0-11.31,11.31l50.06,50.07a8,8,0,0,0,11.32-11.32ZM40,112a72,72,0,1,1,72,72A72.08,72.08,0,0,1,40,112Z"></path>
                                </svg>
                            </div>
                        ),
                        endAdornment: searchQuery != '' && (
                            <div style={{ marginLeft: '8px', marginTop: '4px', cursor: "pointer" }} onClick={() => setSearchQuery('')} >
                                <svg width="12" height="12" viewBox="0 0 12 12" fill="#B2B2B2" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6 0.3125C4.87512 0.3125 3.7755 0.646066 2.8402 1.27102C1.90489 1.89597 1.17591 2.78423 0.745438 3.82349C0.314964 4.86274 0.202333 6.00631 0.421786 7.10958C0.64124 8.21284 1.18292 9.22626 1.97833 10.0217C2.77374 10.8171 3.78716 11.3588 4.89043 11.5782C5.99369 11.7977 7.13726 11.685 8.17651 11.2546C9.21577 10.8241 10.104 10.0951 10.729 9.1598C11.3539 8.2245 11.6875 7.12488 11.6875 6C11.6859 4.49207 11.0862 3.04636 10.0199 1.98009C8.95364 0.913821 7.50793 0.314092 6 0.3125ZM8.05953 7.44047C8.10018 7.48112 8.13243 7.52937 8.15442 7.58248C8.17642 7.63559 8.18775 7.69251 8.18775 7.75C8.18775 7.80748 8.17642 7.86441 8.15442 7.91752C8.13243 7.97063 8.10018 8.01888 8.05953 8.05953C8.01889 8.10018 7.97063 8.13242 7.91752 8.15442C7.86441 8.17642 7.80749 8.18774 7.75 8.18774C7.69252 8.18774 7.63559 8.17642 7.58248 8.15442C7.52938 8.13242 7.48112 8.10018 7.44047 8.05953L6 6.61852L4.55953 8.05953C4.51889 8.10018 4.47063 8.13242 4.41752 8.15442C4.36441 8.17642 4.30749 8.18774 4.25 8.18774C4.19252 8.18774 4.13559 8.17642 4.08248 8.15442C4.02938 8.13242 3.98112 8.10018 3.94047 8.05953C3.89982 8.01888 3.86758 7.97063 3.84558 7.91752C3.82358 7.86441 3.81226 7.80748 3.81226 7.75C3.81226 7.69251 3.82358 7.63559 3.84558 7.58248C3.86758 7.52937 3.89982 7.48112 3.94047 7.44047L5.38149 6L3.94047 4.55953C3.85838 4.47744 3.81226 4.3661 3.81226 4.25C3.81226 4.1339 3.85838 4.02256 3.94047 3.94047C4.02256 3.85838 4.13391 3.81226 4.25 3.81226C4.3661 3.81226 4.47744 3.85838 4.55953 3.94047L6 5.38148L7.44047 3.94047C7.48112 3.89982 7.52938 3.86758 7.58248 3.84558C7.63559 3.82358 7.69252 3.81226 7.75 3.81226C7.80749 3.81226 7.86441 3.82358 7.91752 3.84558C7.97063 3.86758 8.01889 3.89982 8.05953 3.94047C8.10018 3.98112 8.13243 4.02937 8.15442 4.08248C8.17642 4.13559 8.18775 4.19251 8.18775 4.25C8.18775 4.30749 8.17642 4.36441 8.15442 4.41752C8.13243 4.47063 8.10018 4.51888 8.05953 4.55953L6.61852 6L8.05953 7.44047Z" fill="#B2B2B2" />
                                </svg>
                            </div>
                        ),
                    }}
                />
            </div>

            <Box className="portfolio-details-body">

                {/* ================= LEFT ================= */}
                <Box className="left-hotels">
                    <Box className="title-bar">
                        <Tooltip followCursor title={checkedRight.length > 0 ? TOOLTIP_REMOVE_PROPERTIES_FIRST : ""}>

                            <Box sx={{ display: "flex", alignItems: "center", gap: "4px", ml: "-6px" }}>
                                <Checkbox
                                    disabled={checkedRight.length > 0}
                                    checked={
                                        filteredAvailableHotels.length > 0 &&
                                        filteredAvailableHotels.every(h => checkedLeft.includes(h.property_id))
                                    }
                                    onChange={()=>{handleSelectAllLeft(filteredAvailableHotels)}}
                                    icon={unCheckedIcon}
                                    checkedIcon={checkedIcon}
                                />
                                <div>Available Hotels</div>
                            </Box>
                        </Tooltip>
                    </Box>

                    {searchQuery.trim() === "" && availableHotels.length === 0 && emptyHotelListLeft}

                    {hotelsData.length !== 0 &&
                        <OverlayScrollbarsComponent
                            className="custom-overlay-scrollbar scrollable-tab-container"
                            element="div"
                            options={{
                                scrollbars: { autoHide: 'leave', autoHideDelay: 100 },
                                overflow: { x: 'hidden', y: 'scroll' }
                            }}
                            defer
                        >
                            <Box className="hotels-list">
                                {filteredAvailableHotels.map((hotel) => (
                                    <Box className="hotels-row" key={hotel.id}>
                                        <Tooltip followCursor title={checkedRight.length > 0 ? TOOLTIP_REMOVE_PROPERTIES_FIRST : ""}>
                                            <Box sx={{ display: "flex", alignItems: "center", gap: "4px", ml: "-6px" }}>
                                                <Checkbox
                                                    disabled={checkedRight.length > 0}
                                                    checked={checkedLeft.includes(hotel.property_id)}
                                                    onChange={() => handleLeftCheck(hotel.property_id)}
                                                    icon={unCheckedIcon}
                                                    checkedIcon={checkedIcon}
                                                />
                                                <Box sx={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                                                    <div className='hotel-title'><EllipsisWithTooltip width={400} text={hotel.name} /></div>
                                                    <div className='hotel-capacity'>Capacity: {hotel.capacity} </div>
                                                </Box>
                                            </Box>
                                        </Tooltip>
                                    </Box>
                                ))}
                            </Box>
                        </OverlayScrollbarsComponent>
                    }
                </Box>

                {/* ================= BUTTONS ================= */}
                <Box className="add-remove-btns">
                    <Button
                        className='add-remove-btn'
                        fullWidth
                        variant="contained"
                        disabled={checkedLeft.length === 0}
                        onClick={handleAdd}
                    >
                        <div>Add</div>
                    </Button>

                    <Button
                        className='add-remove-btn'
                        fullWidth
                        variant="contained"
                        disabled={checkedRight.length === 0}
                        onClick={handleRemove}
                    >
                        <div>Remove</div>
                    </Button>
                </Box>

                {/* ================= RIGHT ================= */}
                <Box className="right-hotels">
                    <Box className="title-bar">
                        <Tooltip followCursor title={checkedLeft.length > 0 ? TOOLTIP_ADD_PROPERTIES_FIRST : ""}>

                            <Box sx={{ display: "flex", alignItems: "center", gap: "4px", ml: "-6px" }}>
                                <Checkbox
                                    disabled={checkedLeft.length > 0}
                                    checked={
                                        filteredSelectedHotels.length > 0 &&
                                        filteredSelectedHotels.every(h => checkedRight.includes(h.property_id))
                                    }
                                    // onChange={handleSelectAllRight}
                                    onChange={()=>{handleSelectAllRight(filteredSelectedHotels)}}
                                    icon={unCheckedIcon}
                                    checkedIcon={checkedIcon}
                                />
                                <div> <EllipsisWithTooltip width={500} text={"Hotels in "+selectedPortfolio.name} /></div>
                            </Box>
                        </Tooltip>
                    </Box>

                    {searchQuery.trim() === "" && selectedHotels.length === 0 && emptyHotelListRight}

                    {hotelsData.length !== 0 &&
                        <OverlayScrollbarsComponent
                            className="custom-overlay-scrollbar scrollable-tab-container"
                            element="div"
                            options={{
                                scrollbars: { autoHide: 'leave', autoHideDelay: 100 },
                                overflow: { x: 'hidden', y: 'scroll' }
                            }}
                            defer
                        >
                            <Box className="hotels-list">
                                {filteredSelectedHotels.map((hotel) => (
                                    <Box className="hotels-row" key={hotel.id}>
                                        <Tooltip followCursor title={checkedLeft.length > 0 ? TOOLTIP_ADD_PROPERTIES_FIRST : ""}>
                                            <Box sx={{ display: "flex", alignItems: "center", gap: "4px", ml: "-6px" }}>
                                                <Checkbox
                                                    disabled={checkedLeft.length > 0}
                                                    checked={checkedRight.includes(hotel.property_id)}
                                                    onChange={() => handleRightCheck(hotel.property_id)}
                                                    icon={unCheckedIcon}
                                                    checkedIcon={checkedIcon}
                                                />
                                                <Box sx={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                                                    <div className='hotel-title'><EllipsisWithTooltip width={400} text={hotel.name} /></div>
                                                    <div className='hotel-capacity'>Capacity: {hotel.capacity}</div>
                                                </Box>
                                            </Box>
                                        </Tooltip>
                                    </Box>
                                ))}
                            </Box>
                        </OverlayScrollbarsComponent>
                    }
                </Box>

            </Box>
        </Box>
    );
};

export default PortfolioDetailsPage;